import { parser } from './parser';

export const CSRF_PARAM = parser('csrf-param');
export const CSRF_TOKEN = parser('csrf-token');
